'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isDate(value) {
    return value instanceof Date;
}
exports.isDate = isDate;
